
export enum DocumentVisibilityKind {
  LandlordPages = 0,
  LandlordPagesAndTenantPages = 1,
  Public = 2,
}

export enum DialogMessageParticipantKind {
  Unknown = 0,
  Office = 1,
  Tenant = 2,
  Representative = 3,
}

export enum MenuSection {
  Base = 0,
  EconomicManagement = 1,
  TechnicalManagement = 2,
  Other = 3,
}

export enum TenantPageSource {
  None = 0,
  BuiltIn = 1,
  External = 2
}

export enum NotificationKind {
  FaultNotification = 1,
  Errand = 2
}

export enum LicenseTypeKind {
  Unknown = 0,
  /// <summary>
  /// Auotgiro.
  /// </summary>
  AutoGiro = 1,

  /// <summary>
  /// Automatic bank payment import.
  /// </summary>
  AutomaticBankPaymentImport = 2,

  /// <summary>
  /// Automatic invoicing.
  /// </summary>
  AutomaticInvoicing = 3,

  /// <summary>
  /// Automatic reminders.
  /// </summary>
  AutomaticReminders = 4,

  /// <summary>
  /// B2B e-invoicing.
  /// </summary>
  EInvoiceB2B = 5,

  /// <summary>
  /// Invoice printing.
  /// </summary>
  PrintInvoice = 6,

  /// <summary>
  /// Send email.
  /// </summary>
  SendEmail = 7,

  /// <summary>
  /// Send physical mail.
  /// </summary>
  SendPhysicalMail = 8,

  /// <summary>
  /// Send SMS.
  /// </summary>
  SendSms = 9,

  /// <summary>
  /// Index regulation.
  /// </summary>
  IndexRegulation = 10,

  /// <summary>
  /// Extended technical management - rounding.
  /// </summary>
  ExtendedTechnicalManagementRounding = 11,

  /// <summary>
  /// Access to Homepal dashboards.
  /// </summary>
  HomepalDashboards = 12,

  /// <summary>
  /// Allows sending messages through Kivra.
  /// </summary>
  Kivra = 13,

  /// <summary>
  /// Extended technical management - authority inspection.
  /// </summary>
  ExtendedTechnicalManagementAuthorityInspection = 16,

  /// <summary>
  /// [OBSOLETE!] Extended technical management - dwelling inspection.
  /// </summary>
  ExtendedTechnicalManagementDwellingInspection = 17,

  /// <summary>
  /// Extended technical management - generic errands.
  /// </summary>
  ExtendedTechnicalManagementGenericErrands = 18,

  /// <summary>
  /// Extended technical management - tenant errands.
  /// </summary>
  ExtendedTechnicalManagementTenantErrands = 19
}

export function DocumentVisibilityKindToString(documentVisibilityKind: DocumentVisibilityKind) {
  switch (documentVisibilityKind) {
    case DocumentVisibilityKind.LandlordPages:
      return 'CONST.DOCUMENT_VISIBILITY_LANDLORD';

    case DocumentVisibilityKind.LandlordPagesAndTenantPages:
      return 'CONST.DOCUMENT_VISIBILITY_LANDLORD_AND_TENANT';

    case DocumentVisibilityKind.Public:
      return 'CONST.DOCUMENT_VISIBILITY_PUBLIC';
  }
}

export enum MailDeliverySpeed {
  Priority = 0,
  Economy = 1,
}

export function MailDeliverySpeedToString(delivery: MailDeliverySpeed) {
  switch (delivery) {
    case MailDeliverySpeed.Priority:
      return 'CONST.INVOICE_DELIVERY_SPEED_PRIORITY';

    case MailDeliverySpeed.Economy:
      return 'CONST.INVOICE_DELIVERY_SPEED_ECONOMY';
  }
}

export function SenderTypeToString(kind: DialogMessageParticipantKind) {
  switch (kind) {
    case DialogMessageParticipantKind.Representative:
      return 'CHAT.ROLES.REPRESENTATIVE';
    case DialogMessageParticipantKind.Tenant:
      return 'CHAT.ROLES.TENANT';
    case DialogMessageParticipantKind.Office:
      return 'CHAT.ROLES.OFFICE';
    default:
      return 'Unknown';
  }
}

export function MenuSectionToString(section: MenuSection) {
  switch (section) {
    case MenuSection.EconomicManagement:
      return 'DASHBOARD.SECTIONS.ECONOMIC_MANAGEMENT';
    case MenuSection.TechnicalManagement:
      return 'DASHBOARD.SECTIONS.TECHNICAL_MANAGEMENT';
    case MenuSection.Other:
      return 'DASHBOARD.SECTIONS.OTHER';
    default:
      return '';
  }
}

export function TenantPageSourceToString(source: TenantPageSource) {
  switch (source) {
    case TenantPageSource.None:
      return 'PROFILE_SETTINGS_FORM.TENANT_PAGES_SOURCES.NONE';
    case TenantPageSource.BuiltIn:
      return 'PROFILE_SETTINGS_FORM.TENANT_PAGES_SOURCES.BUILT_IN';
    case TenantPageSource.External:
      return 'PROFILE_SETTINGS_FORM.TENANT_PAGES_SOURCES.EXTERNAL';
    default:
      return '';
  }
}

export function NotificationKindToString(source: NotificationKind) {
  switch (source) {
    case NotificationKind.FaultNotification:
      return 'NOTIFICATION_SETTING.NOTIFICATION_KIND.FAULT_NOTIFICATION';
    case NotificationKind.Errand:
      return 'NOTIFICATION_SETTING.NOTIFICATION_KIND.ERRAND';
    default:
      return '';
  }
}

export function NotificationKindDescription(source: NotificationKind) {
  switch (source) {
    case NotificationKind.FaultNotification:
      return 'NOTIFICATION_SETTING.NOTIFICATION_KIND_DESCRIPTION.FAULT_NOTIFICATION';
    case NotificationKind.Errand:
      return 'NOTIFICATION_SETTING.NOTIFICATION_KIND_DESCRIPTION.ERRAND';
    default:
      return '';
  }
}
